import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEcologyPlantHand = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "ecology-plant-hand" }),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: .789,
			y1: 13.493,
			x2: .789,
			y2: 22.493
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M15.789,20.993a3,3,0,0,0-3-3H9.039a3,3,0,0,0-3-3H.789v6Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 6.039,
			y1: 17.993,
			x2: 9.039,
			y2: 17.993
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M12.039,8.993s-1.531,2.62-3.75,2.25c-4.5-.75-3.75-6.75-5.25-9a9.947,9.947,0,0,1,9,.75C14.289,4.493,14.289,6.743,12.039,8.993Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M16.961,11.191s1.063,1.819,2.6,1.563c3.125-.521,2.6-4.688,3.646-6.251a6.908,6.908,0,0,0-6.25.521C15.4,8.066,15.4,9.628,16.961,11.191Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M9.039,5.993s3.75.75,5.25,8.25a12.491,12.491,0,0,1,3.75-4.5"
		})
	]
});
export default SvgEcologyPlantHand;
